@if (depositsByFolder().size) {
    <div class="overflow-x-auto">
        <app-custom-table
            [columns]="columns"
            [isSelectable]="false">
            @for (depositFolder of this.tableRowsData(); track depositFolder.id) {
                @if (formArray.at($index)) {
                    <tr class="hover:!text-black !cursor-auto">
                        <td class="w-3/10">{{ depositFolder.name }}</td>
                        <td class="w-2/10">
                            <app-select
                                [canClear]="false"
                                [options]="getDepositVersionOptions(depositFolder.id)"
                                [placeholder]="getDepositVersionOptions(depositFolder.id)[0].label || ''"
                                (optionSelected)="updateVersion($event, $index)" />
                        </td>
                        <td class="w-2/10">
                            <app-select
                                [canClear]="false"
                                [options]="exportFormatsOptions"
                                [placeholder]="formatDefaultValue[0].label"
                                (optionSelected)="updateFormat($event, $index)" />
                        </td>
                        <td class="w-2/10">
                            <app-select
                                [canClear]="false"
                                [options]="projectionsOptions"
                                [placeholder]="projectionDefaultValue[0].label"
                                (optionSelected)="updateProjection($event, $index)" />
                        </td>
                        <td class="w-1/10">
                            <app-checkbox
                                [checkboxState]="
                                    formArray.at($index).controls.grouped.getRawValue()
                                        ? CheckboxState.CHECKED
                                        : CheckboxState.UNCHECKED
                                "
                                (click)="updateExportDataGroupedState($index)" />
                        </td>
                    </tr>
                }
            }
        </app-custom-table>
    </div>

    <div
        class="flex flex-row align-centre my-3 gap-2 justify-end cursor-pointer"
        (click)="updateExportDataGroupedState()">
        <span class="text-base">{{ 'groupAllDepositsByStandard' | transloco }}</span>
        <app-checkbox [checkboxState]="groupAllCheckState" />
    </div>
} @else {
    <app-loading />
}
